export default "__VITE_ASSET__eus1JFU4__"